import AvailabilityHeatmap from "./availability-heatmap";

export default AvailabilityHeatmap;
